import React, { useState } from "react"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { themeApplyer, remover, artifactApplyer } from "../../tools"

import DefaultTheme from "./default"
import PropstreamTheme from "./propstream"

export const ThemeContext = React.createContext({})

export const Theme = WrappedComponent => props => {
    const { theme: optionsTheme } = useSelector(state => state.options)
    const [theme, setTheme] = useState(optionsTheme)
    const [images, setImages] = useState({})
    const [styles, setStyles] = useState({})
    const [artifacts, setArtifacts] = useState({})
    const addStyle = (name, style) => setStyles(styles => ({ ...styles, [name]: style }))
    const addArtifact = (name, artifact) => setArtifacts(artifacts => ({ ...artifacts, [name]: artifact }))

    useEffect(() => {
        for (const [name, style] of Object.entries(styles)) {
            themeApplyer(`bd-sf-artifact-theme-${name}`, style)
        }
        for (const [name, artifact] of Object.entries(artifacts)) {
            artifactApplyer(`bd-sf-artifact-${name}`, artifact)
        }
        return () => remover("bd-sf-artifact")
    }, [styles])

    return (
        <ThemeContext.Provider value={{ theme, setTheme, images, setImages, addStyle, addArtifact }}>
            {(() => {
                switch (theme) {
                    case "propstream":
                        return <PropstreamTheme />
                    default:
                        return <DefaultTheme />
                }
            })()}
            <WrappedComponent {...props} />
        </ThemeContext.Provider>
    )
}
